import * as Icons from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/lib/constants";

export default function Services() {
  return (
    <section id="services" className="relative section-pad overflow-hidden" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14 lg:mb-20">
          <div className="col-span-12 md:col-span-4">
            <div className="overline mb-4">01 · Services</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1]">
              A studio and a<br /><span className="italic">software house</span>.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 self-end">
            <p className="text-[15.5px] leading-relaxed text-[color:var(--text-muted)] max-w-[520px]">
              Seven interlocking practices under one roof — from the marketing site
              that converts to the internal system that scales. We ship, and then we stay.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            const large = i === 0; // first card spans two on lg
            return (
              <Reveal key={s.key} delay={i * 0.05} className={large ? "lg:col-span-2" : ""}>
                <div
                  className="card-surface trace-border p-8 lg:p-10 h-full relative group"
                  data-testid={`service-card-${s.key}`}
                >
                  <div className="flex items-start justify-between mb-8">
                    <div className="w-11 h-11 rounded-xl grid place-items-center border border-[color:var(--border-strong)]">
                      <Icon size={18} />
                    </div>
                    <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-[color:var(--text-muted)]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl lg:text-[28px] tracking-tight leading-tight mb-3">{s.title}</h3>
                  <p className="text-[14px] text-[color:var(--text-muted)] leading-relaxed mb-6">{s.lead}</p>
                  <ul className={`grid ${large ? "grid-cols-2" : "grid-cols-1"} gap-1.5 text-[13px]`}>
                    {s.items.map((it) => (
                      <li key={it} className="flex items-center gap-2 text-[color:var(--text-muted)]">
                        <span className="w-1 h-1 rounded-full bg-brand-primary" /> {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
